//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import newTaskCard from './new-task-card.vue';
import taskCard from './task-card.vue';
import tasksList from './tasks-list.vue';
import sectionHeader from './section-header.vue';
import panelNavigation from './panel-navigation.vue';
import DropZone from './drop-zone.vue';
import {calcVisibility} from '../utils.js';
import {createList} from '../item.js';
import {taskCardsMap} from '../component-registers.js'

const panelDebounceDelayMs = 150

export default {
  name: 'ListView',
  props: ['panels', 'fab', 'customizable'],
  data: function() {
    return {
      // see comment in TopicBoard
      layoutId: this.$route.params.layoutId,
      // The panel that the view is actually centered on.
      activePanelIndex: 0,
      // The panel that the view is supposed to be centered on. May differ
      // from activePanelIndex during smooth scrolling.
      targetPanelIndex: 0,
      debouncedUpdatePanel: _.debounce((currentPos, currentIndex) => {
        this.activePanelIndex = currentIndex;
        if (currentPos != currentIndex) {
          this.scrollToPanel(currentIndex);
        }
      }, panelDebounceDelayMs),
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  components: {
    newTaskCard,
    sectionHeader,
    panelNavigation,
    taskCard,
    tasksList,
    DropZone,
  },
  computed: {
    hideNavigation() {
      return (this.$taskCardsController.editModeTaskId ||
              this.$taskCardsController.focusOnNewTaskCard);
    },
    panelHashes() {
      return this.panels.map(p => '#' + p.key);
    },
    validLayout() {
      return this.layoutId === 'default'
          || this.$reactiveCache.docs[this.layoutId]
    }
  },
  methods: {
    translatedName(name) {
      switch(name) {
        case "Items without a list":
          return this.$gettext("Items without a list");
        default:
          return name;
      }
    },
    hiddenSectionText(unit) {
      switch (unit) {
        case "days":
          return this.$gettext("more days without visible items");
        case "weeks":
          return this.$gettext("more weeks without visible items");
        case "months":
          return this.$gettext("more months without visible items");
      }
    },
    addColumnFromID() {
      const ID = prompt(this.$gettext('Task/List ID:'), '');
      if (ID) {
        const item = this.$reactiveCache.docs[ID];
        if (!item) {
          alert(`Error: no list or item with ID "${ID}"`);
          return;
        }
        this.addColumnToLayout(ID);
      }
    },
    addColumnToLayout(ID) {
      const layoutDoc = this.$reactiveCache.docs[this.layoutId]
      const layout = layoutDoc.layout.flat()
      if (layout.includes(ID)) {
        const name = this.$reactiveCache.docs[ID].name
        alert(`Cannot add the same column "${name}" twice.`)
        return
      }
      layout.push(ID)
      layoutDoc.layout = layout
      layoutDoc.save()
    },
    createNew() {
      let relation = this.layoutId.startsWith('layout:all')
        ? this.layoutId.split('-')[1]
        : 'subtaskOf'
      console.log(relation)
      this.createNewList(relation)
    },
    createNewList(relation) {
      const promptText = relation === "subtaskOf"
        ? this.$gettext('List name:')
        : this.$gettext('Period name:')
      const name = prompt(promptText, '');
      if (name) {
        const ID = createList(
          name,
          relation,
          this.$reactiveCache,
          this.$defaultDB,
        );
        if (this.layoutId !== 'default' && !this.layoutId.startsWith('layout:all')) {
          this.addColumnToLayout(ID)
        }
      }
    },
    visible(task) {
      return calcVisibility(task, this);
    },
    allowAddingTask(section) {
      return (section.type != 'past');
    },
    showSection(section, index) {
      // only show past section if it contains tasks or it is the first one.
      return section.type != 'past' || section.tasks.length || index==0
    },
    showOmittedSectionInfo(section) {
      return section.previousEmptySections > 0 && section.type != 'future'
    },
    scrollToPanel(panelIndex, behavior = 'smooth') {
      this.targetPanelIndex = panelIndex;
      // Cannot use $refs.panel because their order is not guaranteed.
      const targetPanel = document.getElementById(this.panels[panelIndex].key);
      if (targetPanel) {
        targetPanel.scrollIntoView({behavior});
      }
    },
    updateActivePanelIndex(event) {
      if (this.$root.pendingishDrag) {
        // Don't update the URL during the drag or just after. It will be
        // updated once the drag is finalized.
        return;
      }
      const currentPos = this.$el.scrollLeft / this.$el.clientWidth
      const currentIndex = Math.round(currentPos);
      if (this.activePanelIndex != this.targetPanelIndex &&
         currentIndex != this.targetPanelIndex) {
       // Currently scrolling to requested panel. Don't change the
       // activePanelIndex to avoid interruption. We will change
       // activePanelIndex once we get close enough for it to be the same as
       // targetPanelIndex.
       return;
      }
      if (window.innerWidth <= 1100) {
        this.debouncedUpdatePanel(currentPos, currentIndex)
      }
    },
    dropAtSectionEnd(section) {
      this.$taskCardsController.dropAtSectionEnd(section);
    },
    updateShowcontents(forceRefresh) {
      if (!this.$el.parentElement) {
        // This element is removed from the DOM and just kept alive.
        // Skip the update - it would be broken, because all clientHeight
        // values are 0 now.
        // deactivated() removes the interval while the component is
        // not in the document tree, but is called too late to prevent all
        // "bad" updateShowcontents() calls.
        // Note: this check assumes that list-view is directly handled by
        // VueRouter, otherwise we might need e.g. document.contains(this.$el).
        return;
      }
      if (!this.$refs.tasksLists) {
        // empty dashboard, possibly because the layout document was deleted
        // or is being created.
        return;
      }
      for (let i = 0; i < this.$refs.tasksLists.length; ++i) {
        let tasksList = this.$refs.tasksLists[i];

        let scrollEl = tasksList.$el.parentElement;
        let scrollState = {
          scrollTop: scrollEl.scrollTop,
          clientHeight: scrollEl.clientHeight,
          // Changed clientWidth would imply that the layout might have changed inside.
          clientWidth: scrollEl.clientWidth,
        };
        let lastScrollState = this.savedScrollState[i];
        if (!forceRefresh &&
            lastScrollState &&
            Math.abs(lastScrollState.scrollTop - scrollState.scrollTop) < lastScrollState.clientHeight / 2 &&
            Math.abs(lastScrollState.clientHeight - scrollState.clientHeight) < lastScrollState.clientHeight / 5 &&
            Math.abs(lastScrollState.clientWidth - scrollState.clientWidth) < 1 ) {
          // Nothing to update.
          continue;
        }
        let renderTop = scrollState.scrollTop - scrollState.clientHeight;
        let renderBottom = scrollState.scrollTop + 2 * scrollState.clientHeight;
        this.savedScrollState[i] = scrollState; // Update saved state.
        // Update showcontents for all cards in the column.
        let updates = [];
        for (const el of tasksList.$el.children) {
          const cardInstance = taskCardsMap.get(el);
          if (!cardInstance) {
            continue;
          }
          if (el.style.visibility === 'hidden') {
            // Protect activeEl from changing. This protects us from losing
            // touchmove/pointermove in the middle of drag-and-drop
            // (because Chrome's shenanigans).
            continue;
          }
          if (getComputedStyle(el).display === 'none') {
            continue; // No point in computing position.
          }
          let top = el.offsetTop;
          let bottom = top + el.offsetHeight;
          let newShowContentsValue = bottom > renderTop && top < renderBottom;
          if (newShowContentsValue !== cardInstance.showcontents) {
            // Push the updates to an array and then apply only after all
            // elements in the container were checked. This way we avoid
            // triggering reflows with subsequent scrollTop calls, as might
            // happen if we mixed them with DOM changes.
            updates.push({cardInstance, el, newShowContentsValue});
          }
        }
        for (const update of updates) {
          // The height is very expensive to compute from scratch, because
          // you need to filter the elements list and apply the fold logic.
          // However, once the card is fully rendered, we can reasonably
          // assume that the size won't change without an interaction,
          // and we'll be mostly right by just keeping it as minHeight.
          if (update.newShowContentsValue) {
            // There is a significant risk of a race here, that it will
            // render shorter and only then render the actual contents.
            // But it seems to work reasonably well.
            update.el.style.minHeight = '48px';
          } else {
            update.el.style.minHeight = getComputedStyle(update.el).height;
          }
          update.cardInstance.showcontents = update.newShowContentsValue;
        }
      }
    },
  },
  watch: {
    activePanelIndex(newIndex) {
      this.$router.replace(this.panelHashes[newIndex]);
    },
    '$route': function (to, from) {
      const panelIndex = this.panelHashes.indexOf(to.hash);
      if (panelIndex == -1) return;
      this.scrollToPanel(panelIndex);
    },
  },
  mounted() {
    // Scroll to the correct panel if indicated by # part of url.
    const panelIndex = this.panelHashes.indexOf(this.$route.hash);
    if (panelIndex !== -1) {
      this.scrollToPanel(panelIndex, /* behavior= */'auto'/* immediately */);
    } else if (this.panels.length) {
      // Fix the hash.
      // Note: this happens only once, when the component is created (mounted).
      // The resulting route change (and any other later) will be handled by
      // the $route watcher.
      this.$router.replace(this.panelHashes[0]);
    }

    // Set up task cards virtualization.
    this.$nextTick(() => {
      this.savedScrollState = []; // Intentionally not in data, it is not reactive.
      this.updateShowcontents();
      // Intentionally not in data, it is not reactive.
      this.virtualizationIntervalId = setInterval(this.updateShowcontents, 200);
    });
  },
  deactivated() {
    // Stop calling updateShowcontents. This is just a little optimization,
    // as it is too late to prevent updateShowcontents() from running with
    // $el removed from DOM - we need a separate check there anyway.
    if (this.virtualizationIntervalId) {
      clearInterval(this.virtualizationIntervalId);
      this.virtualizationIntervalId = null;
    }
  },
  activated() {
    // This is evaluated right after mounted(), in which case we are not yet
    // ready to call updateShowcontents(). savedScrollState is set right
    // before the first "proper" call, so it's simple solution to check it.
    if (this.savedScrollState) {
      this.updateShowcontents(true);
      if (!this.virtualizationIntervalId) {
        this.virtualizationIntervalId = setInterval(this.updateShowcontents, 200);
      }
    }
  },
  beforeDestroy() {
    if (this.virtualizationIntervalId) {
      clearInterval(this.virtualizationIntervalId);
    }
    this.virtualizationIntervalId = null;
  },
  updated() {
    if (this.savedScrollState) {
      this.updateShowcontents(/*forceRefresh=*/true);
    }
  },
};
